export const HOME = {
  emergentLink: "home-emergent-link",
};

export const IDS = {
  nav: "site-nav",
  navLogo: "nav-logo",
  navServices: "nav-link-services",
  navProcess: "nav-link-process",
  navStack: "nav-link-stack",
  navContact: "nav-link-contact",
  navCta: "nav-cta",

  hero: "hero-section",
  heroPrompt: "hero-prompt",
  heroTitle: "hero-title",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  heroStatusOnline: "hero-status-online",

  marquee: "tech-marquee",

  services: "services-section",
  serviceCard: (i) => `service-card-${i}`,

  process: "process-section",
  processStep: (i) => `process-step-${i}`,

  stack: "stack-section",
  stackItem: (i) => `stack-item-${i}`,

  stats: "stats-section",
  statItem: (i) => `stat-item-${i}`,

  contact: "contact-section",
  contactEmail: "contact-email-link",
  contactCopy: "contact-copy-btn",

  footer: "site-footer",
};
